<template>
  <div class="panel-wrap">
    <div class="mgs-panel">
      <vant-icon class="icon" name="passed" color="#09BB07" size="60" />
      <div class="title">绑定成功</div>
      <!--    <div class="desc">长按二维码关注公众号</div>-->
      <div class="code">
        <p>长按二维码关注公众号，及时接收消费消息</p>
        <img
          src="@assets/images/qrcode_for_subscribe.jpg"
          alt=""
          width="200px"
          style="margin-bottom: 30px"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { Icon as VantIcon } from "vant";

export default {
  name: "UserSubscribe",
  components: { VantIcon },
  data: function () {
    return {};
  },
};
</script>
<style lang="scss" scoped>
.panel-wrap {
  width: 100%;
  .state {
  }
}
.mgs-panel {
  background-color: #fff;
  border-radius: 4px;
  width: 92%;
  min-height: 270px;
  margin: 10px auto;
  padding-top: 30px;
  text-align: center;

  .title {
    font-size: 16px;
    font-weight: 700;
    color: #313131;
    margin: 15px 0 8px;
  }

  .desc {
    font-size: 12px;
    color: #8c8c8c;
  }

  .btn {
    margin-top: 20px;
  }

  .code {
    font-size: 12px;
    margin-top: 30px;
    color: #8c8c8c;
  }
}
</style>
